import React, { useState, useRef, useEffect } from "react";
import T from "prop-types";
import classNames from "classnames";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import { Link } from "react-router-dom";
import { trim } from "lodash";
import api from "APP_ROOT/api";
import { LIST_CONTAINER_HEIGHT, PART_ITEM_HEIGHT } from "./constants";

function AllParts({ partId }) {
  const [parts, setParts] = useState([]);
  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const listRef = useRef(null);
  const activePartRef = useRef(null);

  useEffect(
    () => {
      api.parts.all(partId, 0).then(({ data }) => {
        setParts(data.results);
        setInitialFetchDone(true);
      });
      return function cleanup() {};
    },
    [partId]
  );

  useEffect(
    () => {
      if (
        initialFetchDone &&
        activePartRef != null &&
        activePartRef.current != null
      ) {
        const activePart = activePartRef.current;
        const list = listRef.current;

        const centerOffset =
          (LIST_CONTAINER_HEIGHT / PART_ITEM_HEIGHT - 1) * PART_ITEM_HEIGHT / 2;

        list.scrollTop = activePart.offsetTop - list.offsetTop - centerOffset;
      }

      return function cleanup() {};
    },
    [partId, initialFetchDone]
  );

  const className = part =>
    classNames(getPartNumberColorClassNameByTierType(part.tierType), {
      "text-bold": partId === part.uuid
    });

  return (
    <div
      style={{ overflow: "scroll", height: LIST_CONTAINER_HEIGHT }}
      ref={listRef}
    >
      {parts.map(p => (
        <div
          style={{ width: "100%" }}
          ref={p[0] === partId ? activePartRef : null}
        >
          <Link
            className={className({ uuid: p[0], tierType: p[2] })}
            to={`/parts/${p[0]}`}
          >
            <span className="align-middle">{trim(p[1])}</span>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default AllParts;

AllParts.propTypes = {
  partId: T.number.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/AllParts/AllParts.jsx